import React from 'react'
import Hero from '../Components/marketing/sections/Hero'
import Products from '../Components/marketing/sections/Products'
import Dispenser from '../Components/marketing/sections/Dispenser'
import WhoWeServe from '../Components/marketing/sections/WhoWeServe'
import Impact from '../Components/marketing/sections/Impact'
import Contact from '../Components/marketing/sections/Contact'

const Home = () => (
  <>
    <Hero />
    <Products />
    <Dispenser />
    <WhoWeServe />
    <Impact />
    <Contact />
  </>
)

export default Home
